var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.componentShow)?_c('el-button',{class:_vm.btClass,attrs:{"type":_vm.type,"loading":_vm.queryLoading,"disabled":_vm.disabled},on:{"click":_vm.methodFun}},[_vm._v(_vm._s(_vm.text))]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../vue-loader/lib/template-compiler?{"id":"data-v-7d6b92a8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../vue-loader/lib/selector.js?type=template&index=0!./src/components/ZmButton/index.vue
// module id = null
// module chunks = 